var _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _path14, _g, _path15, _circle3, _path16, _path17, _path18, _path19, _g2, _ellipse, _ellipse2, _path20, _path21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadges(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 162,
    viewBox: "0 0 204 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 136.5,
    r: 13.03,
    stroke: "#FFBF39",
    strokeWidth: 2.5,
    strokeMiterlimit: 3.8637,
    strokeLinejoin: "round",
    strokeDasharray: "2.48 2.48"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.4097 129.082C64.0479 130.621 64.4935 132.26 64.7164 133.969L63.477 134.13C63.578 134.905 63.6303 135.696 63.6303 136.5C63.6303 137.304 63.578 138.095 63.477 138.87L64.7165 139.031C64.4935 140.74 64.0479 142.379 63.4097 143.918L62.255 143.44C61.6441 144.913 60.8442 146.289 59.8852 147.537L60.8763 148.298C59.8446 149.641 58.641 150.844 57.2985 151.876L56.5368 150.885C55.2889 151.844 53.9131 152.644 52.4399 153.255L52.9187 154.409C51.3796 155.048 49.7405 155.493 48.0315 155.716L47.8698 154.477C47.0948 154.578 46.3039 154.63 45.5003 154.63C44.6966 154.63 43.9057 154.578 43.1307 154.477L42.969 155.716C41.26 155.493 39.6209 155.048 38.0818 154.409L38.5606 153.255C37.0874 152.644 35.7116 151.844 34.4637 150.885L33.702 151.876C32.3595 150.844 31.1559 149.641 30.1242 148.298L31.1153 147.537C30.1563 146.289 29.3564 144.913 28.7455 143.44L27.5908 143.918C26.9526 142.379 26.507 140.74 26.2841 139.031L27.5236 138.87C27.4225 138.095 27.3703 137.304 27.3703 136.5C27.3703 135.696 27.4225 134.905 27.5236 134.13L26.2841 133.969C26.507 132.26 26.9526 130.621 27.5908 129.082L28.7455 129.56C29.3564 128.087 30.1563 126.711 31.1153 125.463L30.1242 124.702C31.1559 123.359 32.3595 122.156 33.702 121.124L34.4637 122.115C35.7116 121.156 37.0874 120.356 38.5606 119.745L38.0818 118.591C39.6209 117.952 41.26 117.507 42.969 117.284L43.1307 118.523C43.9057 118.422 44.6966 118.37 45.5003 118.37C46.3039 118.37 47.0948 118.422 47.8698 118.523L48.0315 117.284C49.7405 117.507 51.3796 117.952 52.9187 118.591L52.4399 119.745C53.9131 120.356 55.2889 121.156 56.5368 122.115L57.2985 121.124C58.641 122.156 59.8446 123.359 60.8763 124.702L59.8852 125.463C60.8442 126.711 61.6441 128.087 62.255 129.56L63.4097 129.082Z",
    stroke: "#FFBF39",
    strokeWidth: 2.5,
    strokeMiterlimit: 3.8637,
    strokeLinejoin: "round",
    strokeDasharray: "4.95 4.95"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 136.5,
    r: 24.25,
    stroke: "#FFBF39",
    strokeWidth: 2.5,
    strokeMiterlimit: 3.8637,
    strokeLinejoin: "round",
    strokeDasharray: "7.43 7.43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.653 37.5273C145.603 36.699 146.262 36 147.091 36V36C147.921 36 148.579 36.699 148.53 37.5273L147.091 61.5L145.653 37.5273Z",
    fill: "#FFBF39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.653 85.4727C145.603 86.301 146.262 87 147.091 87V87C147.921 87 148.579 86.301 148.53 85.4727L147.091 61.5L145.653 85.4727Z",
    fill: "#FFBF39"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.654 41.3568C133.197 40.6643 133.418 39.7298 134.136 39.315V39.315C134.855 38.9001 135.775 39.1763 136.146 39.9184L146.886 61.3986L133.654 41.3568Z",
    fill: "#FFBF39"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.627 82.8787C157.998 83.6209 158.918 83.8971 159.636 83.4822V83.4822C160.355 83.0673 160.576 82.1328 160.118 81.4404L146.886 61.3985L157.627 82.8787Z",
    fill: "#FFBF39"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.654 81.4405C133.197 82.1329 133.418 83.0674 134.136 83.4823V83.4823C134.855 83.8972 135.775 83.621 136.146 82.8788L146.886 61.3986L133.654 81.4405Z",
    fill: "#FFBF39"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.627 39.9185C157.998 39.1764 158.918 38.9002 159.636 39.315V39.315C160.355 39.7299 160.576 40.6644 160.118 41.3569L146.886 61.3987L157.627 39.9185Z",
    fill: "#FFBF39"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.02 51.0644C125.278 50.6933 125.001 49.7737 125.416 49.0551V49.0551C125.831 48.3365 126.766 48.1159 127.458 48.5731L147.5 61.8051L126.02 51.0644Z",
    fill: "#FFBF39"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M167.542 75.0371C168.234 75.4943 169.169 75.2737 169.584 74.5551V74.5551C169.999 73.8365 169.722 72.9169 168.98 72.5458L147.5 61.8051L167.542 75.0371Z",
    fill: "#FFBF39"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M126.02 71.7331C125.278 72.1042 125.001 73.0238 125.416 73.7424V73.7424C125.831 74.461 126.766 74.6816 127.458 74.2244L147.5 60.9924L126.02 71.7331Z",
    fill: "#FFBF39"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M167.542 47.7603C168.234 47.3032 169.169 47.5238 169.584 48.2424V48.2424C169.999 48.961 169.722 49.8806 168.98 50.2517L147.5 60.9924L167.542 47.7603Z",
    fill: "#FFBF39"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.527 59.5539C122.699 59.5042 122 60.1625 122 60.9923V60.9923C122 61.822 122.699 62.4803 123.527 62.4306L147.5 60.9923L123.527 59.5539Z",
    fill: "#FFBF39"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171.473 59.5539C172.301 59.5042 173 60.1625 173 60.9923V60.9923C173 61.822 172.301 62.4803 171.473 62.4306L147.5 60.9923L171.473 59.5539Z",
    fill: "#FFBF39"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 20.7037,
    width: 6.37037,
    height: 1.59259,
    fill: "#FFBF39"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75936,
    y: 20.7039,
    width: 6.37037,
    height: 1.59259,
    fill: "#FFBF39"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8704,
    y: 20.7039,
    width: 6.37037,
    height: 1.59259,
    fill: "#FFBF39"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.6296,
    y: 20.7039,
    width: 6.37037,
    height: 1.59259,
    fill: "#FFBF39"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3149,
    y: 20.7037,
    width: 6.37037,
    height: 1.59259,
    fill: "#FFBF39"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7039,
    y: 43,
    width: 6.37037,
    height: 1.59259,
    transform: "rotate(-90 20.7039 43)",
    fill: "#FFBF39"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7037,
    y: 34.2407,
    width: 6.37037,
    height: 1.59259,
    transform: "rotate(-90 20.7037 34.2407)",
    fill: "#FFBF39"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7037,
    y: 15.1296,
    width: 6.37037,
    height: 1.59259,
    transform: "rotate(-90 20.7037 15.1296)",
    fill: "#FFBF39"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7038,
    y: 6.37036,
    width: 6.37037,
    height: 1.59259,
    transform: "rotate(-90 20.7038 6.37036)",
    fill: "#FFBF39"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7037,
    y: 24.6853,
    width: 6.37037,
    height: 1.59259,
    transform: "rotate(-90 20.7037 24.6853)",
    fill: "#FFBF39"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 6.86002,
    y: 5.73425,
    width: 6.37037,
    height: 1.59259,
    transform: "rotate(45 6.86002 5.73425)",
    fill: "#FFBF39"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 13.0538,
    y: 11.9281,
    width: 6.37037,
    height: 1.59259,
    transform: "rotate(45 13.0538 11.9281)",
    fill: "#FFBF39"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5674,
    y: 25.4417,
    width: 6.37037,
    height: 1.59259,
    transform: "rotate(45 26.5674 25.4417)",
    fill: "#FFBF39"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 32.761,
    y: 31.6354,
    width: 6.37037,
    height: 1.59259,
    transform: "rotate(45 32.761 31.6354)",
    fill: "#FFBF39"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8108,
    y: 18.6848,
    width: 6.37037,
    height: 1.59259,
    transform: "rotate(45 19.8108 18.6848)",
    fill: "#FFBF39"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 5.73404,
    y: 36.1399,
    width: 6.37037,
    height: 1.59259,
    transform: "rotate(-45 5.73404 36.1399)",
    fill: "#FFBF39"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9277,
    y: 29.9462,
    width: 6.37037,
    height: 1.59259,
    transform: "rotate(-45 11.9277 29.9462)",
    fill: "#FFBF39"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 25.4413,
    y: 16.4327,
    width: 6.37037,
    height: 1.59259,
    transform: "rotate(-45 25.4413 16.4327)",
    fill: "#FFBF39"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6351,
    y: 10.2388,
    width: 6.37037,
    height: 1.59259,
    transform: "rotate(-45 31.6351 10.2388)",
    fill: "#FFBF39"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6842,
    y: 23.1892,
    width: 6.37037,
    height: 1.59259,
    transform: "rotate(-45 18.6842 23.1892)",
    fill: "#FFBF39"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2594,
    y: 26.1818,
    width: 1.59259,
    height: 9.55555,
    transform: "rotate(-70 30.2594 26.1818)",
    fill: "#FFBF39"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 1.59259,
    height: 9.55555,
    transform: "matrix(0.34202 0.939693 0.939693 -0.34202 30.2594 16.8052)",
    fill: "#FFBF39"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 24.6851,
    y: 30.804,
    width: 1.59259,
    height: 9.55556,
    transform: "rotate(-20 24.6851 30.804)",
    fill: "#FFBF39"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 1.59259,
    height: 9.55556,
    transform: "matrix(0.939693 0.34202 0.34202 -0.939693 24.6851 12.1643)",
    fill: "#FFBF39"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 1.59259,
    height: 9.55555,
    transform: "matrix(-0.34202 -0.939693 -0.939693 0.34202 12.7092 26.1818)",
    fill: "#FFBF39"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7092,
    y: 16.8053,
    width: 1.59259,
    height: 9.55555,
    transform: "rotate(110 12.7092 16.8053)",
    fill: "#FFBF39"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 1.59259,
    height: 9.55556,
    transform: "matrix(-0.939693 -0.34202 -0.34202 0.939693 18.2834 30.804)",
    fill: "#FFBF39"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2834,
    y: 12.1646,
    width: 1.59259,
    height: 9.55556,
    transform: "rotate(160 18.2834 12.1646)",
    fill: "#FFBF39"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3385_6742",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 106,
    width: 138,
    height: 49
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.668 106.07H196.685C198.04 106.07 198.401 107.939 197.144 108.443L83.3054 154.134L60.5878 142.46L72.4536 122.858L103.668 106.07Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3385_6742)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 109.203,
    cy: 122.338,
    r: 68.5038,
    transform: "rotate(40.747 109.203 122.338)",
    fill: "url(#paint0_linear_3385_6742)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1249 149.837C89.4149 155.443 76.091 154.859 66.3809 149.253C56.6709 143.647 61.6122 138.832 67.2351 128.482C76.9451 122.876 89.4149 122.307 99.1249 127.913C106.458 140.825 108.835 144.231 99.1249 149.837Z",
    fill: "#648CFE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1516,
    cy: 13.1516,
    r: 13.1516,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 83.1815 115.955)",
    fill: "#A8CCF8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.788 28.9246C31.7193 23.6361 37.0711 21.8893 41.0627 23.3677L54.3714 28.2969L51.6974 35.5167L38.3886 30.5875C38.3635 30.5782 38.34 30.5707 38.3183 30.5646C37.4588 35.7319 37.2156 44.6708 39.4477 54.0405C41.7174 63.5679 46.4617 73.2168 55.3579 79.9512L50.7109 86.0898C39.9696 77.9586 34.5 66.4945 31.9581 55.8247C29.4233 45.1842 29.716 35.0114 30.788 28.9246Z",
    fill: "#A8CCF8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9181 107.828H90.4609V126.42C90.4609 128.169 89.6219 129.851 88.0888 130.692C84.5109 132.655 81.8152 132.702 78.2272 130.693C76.7275 129.853 75.9181 128.193 75.9181 126.474V107.828Z",
    fill: "#E7F1FD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5475 110.824C104.635 110.824 122.54 79.4173 122.54 40.6758H42.5547C42.5547 79.4173 60.4601 110.824 82.5475 110.824Z",
    fill: "#E7F1FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3385_6742",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 40,
    width: 81,
    height: 71
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5475 110.824C104.635 110.824 122.54 79.4173 122.54 40.6758H42.5547C42.5547 79.4173 60.4601 110.824 82.5475 110.824Z",
    fill: "#FFBF39"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3385_6742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.8716 109.325C86.0752 111.721 122.714 87.0144 129.344 24.7797L130.944 112.106C121.249 121.587 88.4705 132.423 58.8716 109.325Z",
    fill: "#2538BF"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.5475,
    cy: 40.4617,
    rx: 39.9928,
    ry: 19.4617,
    fill: "#648CFE"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.5479,
    cy: 40.0344,
    rx: 33.84,
    ry: 16.4676,
    fill: "#E7F1FD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M114.221 58.8079C116.716 59.3069 148.017 61.6342 128.881 87.6365C120.685 98.7738 110.35 105.904 99.8707 101.413",
    stroke: "#A8CCF8",
    strokeWidth: 10.6003,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2685 66.9792C66.5579 65.5857 68.653 66.4821 69.326 68.2873L71.632 74.4736C71.9329 75.2809 72.6081 76.0292 73.3045 76.3272L78.6407 78.6103C80.1978 79.2765 81.1032 81.7054 79.962 82.1549L76.051 83.6951C75.5406 83.8961 75.3988 84.5788 75.6998 85.3861L78.0058 91.5724C78.6787 93.3776 77.1431 93.9823 75.7649 92.4549L71.0417 87.2205C70.4254 86.5374 69.6625 86.211 69.1521 86.412L65.2411 87.9523C64.0999 88.4017 62.2454 86.3466 62.5349 84.9531L63.5268 80.1779C63.6563 79.5547 63.3266 78.6703 62.7102 77.9872L57.9871 72.7528C56.6088 71.2254 56.9983 69.3505 58.5554 70.0167L63.8916 72.2998C64.588 72.5978 65.1471 72.3776 65.2765 71.7544L66.2685 66.9792Z",
    fill: "#FFBF39"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3385_6742",
    x1: 74.9515,
    y1: 182.279,
    x2: 150.306,
    y2: 64.1099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2538BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#2538BF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadges);
export default __webpack_public_path__ + "static/media/badges.36c3ae06336fbd05592c9c1946795b05.svg";
export { ForwardRef as ReactComponent };